import tw, { styled } from 'twin.macro';
import { Hits, SearchBox } from 'react-instantsearch-hooks-web';

export const StyledSearchBox = styled(SearchBox)`
  ${tw`mx-8 mb-4`}

  form {
    ${tw`relative bg-transparent`}
  }

  input {
    ${tw`w-full`}
    ${tw`px-4 py-2`}
    ${tw`border border-solid border-border`}
    ${tw`focus:border-primary`}
    ${tw`placeholder:text-sm`}
    ${tw`focus:border-border-dark`}
  }

  input::-webkit-search-cancel-button {
    cursor: pointer;
  }

  .ais-SearchBox-loadingIndicator:not([hidden]) {
    ${tw`absolute right-[11px] top-[10px]`}
  }

  .ais-SearchBox-reset,
  .ais-SearchBox-submit {
    ${tw`hidden`}
  }
`;

export const StyledHits = styled(Hits)`
  ${tw`mx-5 mb-5`}
`;
